import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './Footer.st.css';
import Button from '../../../Button';
import { dataHooks } from '../../constants';
import Divider from '../../../Divider';
import { useBaseModalLayoutContext } from '../../BaseModalLayoutContext';
export var Footer = function Footer(_ref) {
  var dataHook = _ref.dataHook,
      className = _ref.className,
      showFooterDivider = _ref.showFooterDivider;

  var _useBaseModalLayoutCo = useBaseModalLayoutContext(),
      footerClassName = _useBaseModalLayoutCo.footerClassName,
      theme = _useBaseModalLayoutCo.theme,
      actionsSize = _useBaseModalLayoutCo.actionsSize,
      sideActions = _useBaseModalLayoutCo.sideActions,
      secondaryButtonText = _useBaseModalLayoutCo.secondaryButtonText,
      secondaryButtonOnClick = _useBaseModalLayoutCo.secondaryButtonOnClick,
      secondaryButtonProps = _useBaseModalLayoutCo.secondaryButtonProps,
      primaryButtonText = _useBaseModalLayoutCo.primaryButtonText,
      primaryButtonOnClick = _useBaseModalLayoutCo.primaryButtonOnClick,
      primaryButtonProps = _useBaseModalLayoutCo.primaryButtonProps;

  className = classNames(footerClassName, className);
  var hasPrimaryButton = primaryButtonText || primaryButtonOnClick || primaryButtonProps;
  var hasSecondaryButton = secondaryButtonText || secondaryButtonOnClick || secondaryButtonProps;
  var hasFooter = hasPrimaryButton || hasSecondaryButton || sideActions;
  return hasFooter && /*#__PURE__*/React.createElement("div", _extends({
    "data-hook": dataHook,
    "data-divider": showFooterDivider
  }, styles('root', {
    showDivider: showFooterDivider
  }, {
    className: className
  })), /*#__PURE__*/React.createElement(Divider, {
    className: styles.divider,
    dataHook: dataHooks.footerDivider
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.innerContent
  }, sideActions && /*#__PURE__*/React.createElement("div", {
    "data-hook": dataHooks.footerSideActions,
    className: styles.sideActions
  }, sideActions), (hasPrimaryButton || hasSecondaryButton) && /*#__PURE__*/React.createElement("div", {
    className: styles.actions
  }, hasSecondaryButton && /*#__PURE__*/React.createElement(Button, _extends({
    skin: theme,
    size: actionsSize,
    onClick: secondaryButtonOnClick,
    priority: "secondary"
  }, secondaryButtonProps, {
    dataHook: dataHooks.footerSecondaryButton
  }), secondaryButtonText), hasPrimaryButton && /*#__PURE__*/React.createElement(Button, _extends({
    skin: theme,
    size: actionsSize,
    onClick: primaryButtonOnClick
  }, primaryButtonProps, {
    dataHook: dataHooks.footerPrimaryButton
  }), primaryButtonText)))) || null;
};
Footer.displayName = 'BaseModalLayout.Footer';
Footer.propTypes = {
  /** additional css classes */
  className: PropTypes.string,

  /** data hook for testing */
  dataHook: PropTypes.string,

  /** a theme for the Footer, will affect footer action buttons skin */
  theme: PropTypes.oneOf(['standard', 'premium', 'destructive']),

  /** will determine the action buttons size*/
  actionsSize: Button.propTypes.size,

  /** a text for the primary action button */
  primaryButtonText: PropTypes.string,

  /** a callback for when the primary action button is clicked */
  primaryButtonOnClick: PropTypes.func,

  /** Passed to the primary action button as props without any filter / mutation */
  primaryButtonProps: function () {
    var _Button$propTypes = Button.propTypes,
        dataHook = _Button$propTypes.dataHook,
        buttonProps = _objectWithoutProperties(_Button$propTypes, ["dataHook"]);

    return PropTypes.shape(buttonProps);
  }(),

  /** a text for the secondary action button */
  secondaryButtonText: PropTypes.string,

  /** callback for when the secondary action button is clicked */
  secondaryButtonOnClick: PropTypes.func,

  /** Passed to the secondary button as props without any filter / mutation */
  secondaryButtonProps: function () {
    var _Button$propTypes2 = Button.propTypes,
        dataHook = _Button$propTypes2.dataHook,
        buttonProps = _objectWithoutProperties(_Button$propTypes2, ["dataHook"]);

    return PropTypes.shape(buttonProps);
  }(),

  /** side actions node, to be rendered as the first element on the same row as the action buttons */
  sideActions: PropTypes.node,

  /** shows the footer divider */
  showFooterDivider: PropTypes.bool
};
Footer.defaultProps = {
  showFooterDivider: false
};